import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineMail, HiOutlineBookOpen, HiOutlinePhone, HiOutlineSparkles } from 'react-icons/hi';
import { UserContext } from '../../../context/UserContext';
import { getVenueTypeConfig } from '../../../lib/consts/venueTypes';

export default function Support() {
  // UserContext es posicional: venueType va en la 11 (mismo patrón que
  // ClientDetailModal y ProductModal). Sin esto, esta pantalla le decía "Socios"
  // a un bistró, que llama "Clientes" a lo mismo — el fallo que da pie a que
  // nadie se fíe de la ayuda escrita a mano.
  const venueType = (useContext(UserContext) || [])[11];
  const { memberLabel } = getVenueTypeConfig(venueType);

  const faqItems = [
    {
      q: `¿Cómo añado un nuevo ${memberLabel.toLowerCase().replace(/s$/, '')}?`,
      a: `Ve a ${memberLabel} y pulsa el botón de crear. Completa el formulario y guarda.`,
    },
    { q: '¿Cómo cambio mi contraseña?', a: 'Entra en Perfil (menú inferior) y usa la sección "Seguridad".' },
    { q: '¿Dónde veo el historial de ventas?', a: 'En Panel de Control verás estadísticas y en Contabilidad el detalle de transacciones.' },
    { q: '¿Puedo usar ClubsAgent en el móvil?', a: 'Sí, tenemos app móvil para gestionar entradas y consultas en el dispensario.' },
  ];

  return (
    <div className="max-w-4xl mx-auto px-3 sm:px-4 py-2 sm:py-4 max-w-full">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Ayuda y Soporte</h1>
      <p className="text-gray-600 mb-4 sm:mb-8 text-sm sm:text-base">Resuelve dudas y contacta con nosotros.</p>

      {/* Va PRIMERO, antes que las preguntas frecuentes y que el email: es lo
          único que responde al momento y sobre los datos reales de este club.
          Cuatro preguntas escritas a mano no cubren lo que pregunta la gente. */}
      <section className="mb-10">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlineSparkles className="text-purple-600" />
          Pregúntale al Asistente
        </h2>
        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm">
          <p className="text-gray-600 text-sm sm:text-base">
            Responde al momento sobre los datos de tu local: ventas, stock, {memberLabel.toLowerCase()},
            caja y aforo. Es el camino más rápido para casi cualquier duda del día a día.
          </p>
          <Link
            to="/asistente-ia"
            className="mt-4 inline-flex items-center justify-center rounded-lg bg-purple-600 px-4 py-2 text-sm font-semibold text-white hover:bg-purple-700 min-h-[44px]"
          >
            Abrir el Asistente
          </Link>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlineBookOpen className="text-purple-600" />
          Preguntas frecuentes
        </h2>
        <ul className="space-y-3 sm:space-y-4">
          {faqItems.map((item, i) => (
            <li key={i} className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 shadow-sm">
              <p className="font-medium text-gray-900">{item.q}</p>
              <p className="text-gray-600 text-sm mt-1">{item.a}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="mb-10">
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlineMail className="text-purple-600" />
          Contactar soporte
        </h2>
        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm">
          <p className="text-gray-600 mb-2 text-sm sm:text-base">Email: <a href="mailto:soporte@clubsagent.ai" className="text-purple-600 hover:underline">soporte@clubsagent.ai</a></p>
          <p className="text-gray-600 text-sm">Te responderemos en menos de 24 horas laborables.</p>
        </div>
      </section>

      <section>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-4">
          <HiOutlinePhone className="text-purple-600" />
          Acerca de ClubsAgent
        </h2>
        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm text-gray-600 text-sm">
          <p>ClubsAgent Beta 1.0.0 — Gestión de dispensarios y socios.</p>
          <p className="mt-2">© 2026 ClubsAgent. Todos los derechos reservados.</p>
        </div>
      </section>
    </div>
  );
}
